import { EZasadyVyplaty } from 'enums/isin/udaje/zasadyVyplaty';

const pouzitiZiskuSelect = [
    {
        value: EZasadyVyplaty.VYNO,
        labelcz: 'ISIN_EMISE_LIST_ZISK_VF'
    },
    {
        value: EZasadyVyplaty.RUST,
        labelcz: 'ISIN_EMISE_LIST_ZISK_AF'
    },
    {
        value: EZasadyVyplaty.SMIS,
        labelcz: 'ISIN_EMISE_LIST_ZISK_SF'
    }
];

export default pouzitiZiskuSelect;
